import { IonChip, IonIcon, IonLabel, IonSkeletonText, useIonModal } from "@ionic/react";
import { useRfidProfileQuery } from "../query/rfidProfileQuery";
import RfidProfileModal from "../modals/RfidProfileModal";
import { modalController } from "@ionic/core";
import { getRfidDisplayLabel } from "../utils/rfidDisplay";
import styles from "./RfidChip.module.css";

interface RfidChipProps {
    rfidCode: string,
    deviceId?: string,
    /** Inline variant for use within running text, e.g. event and rule summaries. */
    compact?: boolean
}

const RfidChip: React.FC<RfidChipProps> = ({ rfidCode, deviceId, compact = false }) => {
    const query = useRfidProfileQuery(rfidCode, deviceId);
    const [presentProfile, dismissProfile] = useIonModal(RfidProfileModal, {
        dismiss: (data: string, role: string) => dismissProfile(data, role),
        rfidCode
    });

    const openProfile = (e: any) => {
        (async () => {
            presentProfile({
                presentingElement: await modalController.getTop() || document.getElementsByTagName('ion-router-outlet')[0]
            });
        })();

        e.stopPropagation();
        e.preventDefault();
        return false;
    }

    const isNamed = !!query.data?.label?.trim();

    if (compact) {
        return (
            <button
                type="button"
                className={`${styles.compact} ${isNamed ? '' : styles.compactUnnamed}`}
                onClick={openProfile}
            >
                {query.isLoading
                    ? <IonSkeletonText className={styles.compactSkeleton} animated />
                    : getRfidDisplayLabel(rfidCode, query.data?.label)}
            </button>
        );
    }

    return (
        <IonChip key={rfidCode} color={isNamed ? 'primary' : 'dark'} onClick={openProfile}>
            <IonIcon src="/assets/rfid/tag-simple.svg" aria-hidden />
            {query.isLoading
                ? <IonLabel><IonSkeletonText style={{ width: '42px' }} animated /></IonLabel>
                : <IonLabel>{getRfidDisplayLabel(rfidCode, query.data?.label)}</IonLabel>}
        </IonChip>
    );
};

export default RfidChip;
